import { AfterViewInit, Component, ContentChildren, EventEmitter, Output, QueryList } from '@angular/core';
import { ITabViewState } from '../../services/rc-tab.service';

export interface ITabViewChildComponent {
  tabViewState: ITabViewState;
}

@Component({
  selector: 'app-rc-tab-view',
  templateUrl: './rc-tab-view.component.html',
  styleUrls: ['./rc-tab-view.component.scss']
})
export class RcTabViewComponent implements AfterViewInit, ITabViewState {

  // ITabViewState fields
  public tabTitle: string;
  public icon: string;
  public tabHasIndicator: string;
  public selected = false;
  public enabled = true;
  public visible = true;

  @Output() public onTabShow = new EventEmitter<void>();
  @Output() public onTabHide = new EventEmitter<void>();

  @ContentChildren('tabcontent') contentComponents: QueryList<ITabViewChildComponent>;

  constructor() { }

  ngAfterViewInit() {
    this.contentComponents.changes.subscribe(childs => {
      childs.forEach((child) => {
        child.tabViewState = this;
      });
    });
  }

  public show() {
      this.selected = true;
      setTimeout(()=>{

        this.onTabShow.emit();
      });
  }

  public hide() {
      this.selected = false;
      this.onTabHide.emit();
  }
}
